<div class="extra-points-container"
    [ngClass]="position">
    <p>+{{ points }} {{ 'STAMPS_LOWERCASE' | translate }}</p>
</div>